import React from 'react';

const JoinWithUs = () => {
  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow-md rounded-md font-sans">
      <h1 className="text-center text-2xl font-bold mb-6">Join With Us</h1>
      <form action="/submit-join" method="post" className="space-y-4">
        <div>
          <label htmlFor="fullname" className="block text-gray-700 font-bold mb-2">
            Full Name:
          </label>
          <input
            type="text"
            id="fullname"
            name="fullname"
            placeholder="Enter your full name"
            required
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-gray-700 font-bold mb-2">
            Email Address:
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email address"
            required
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>
        <div>
          <label htmlFor="phone" className="block text-gray-700 font-bold mb-2">
            Phone Number:
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Optional"
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>
        <div>
          <label htmlFor="education" className="block text-gray-700 font-bold mb-2">
            Education:
          </label>
          <select
            id="education"
            name="education"
            className="w-full p-2 border border-gray-300 rounded"
            required
          >
            <option value="">Select your education level</option>
            <option value="high-school">High School</option>
            <option value="associate">Associate Degree</option>
            <option value="bachelor">Bachelor's Degree</option>
            <option value="master">Master's Degree</option>
            <option value="phd">PhD</option>
            <option value="other">Other</option>
          </select>
        </div>

        {/* <div>
          <label htmlFor="educationStream" className="block text-gray-700 font-bold mb-2">
            Education Stream:
          </label>
          <select
            id="educationStream"
            name="educationStream"
            className="w-full p-2 border border-gray-300 rounded"
            required
          >
            <option value="">Select your stream</option>
            <option value="science">Science</option>
            <option value="commerce">Commerce</option>
            <option value="arts">Arts</option>
            <option value="other">Other</option>
          </select>
        </div> */}

        <div>
          <label htmlFor="cv" className="block text-gray-700 font-bold mb-2">
            Upload Your CV:
          </label>
          <input
            type="file"
            id="cv"
            name="cv"
            accept=".pdf,.doc,.docx"
            required
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-200"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default JoinWithUs;
